/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const reserveStatusEnumSchema = z
	.enum(["waiting_creation", "waiting_prepayment", "new", "started", "cancelling", "closed", "cancelled", "failed"])
	.describe(
		"* `waiting_creation` - Ожидает создания в iiko\n* `waiting_prepayment` - Ожидает предоплаты\n* `new` - Забронирован\n* `started` - Гости пришли\n* `cancelling` - Отменяется\n* `closed` - Завершён\n* `cancelled` - Отменён\n* `failed` - Ошибка создания",
	);
